import { IMicros } from "@tm/models"
import PrintOrderButton from "../../components/_shared/buttons/PrintOrderButton"

type Props = IMicros["cis"]["print-order"]

export default function PrintOrderComponent({ orderId, textId, iconName }: Props) {
    return <PrintOrderButton orderId={orderId} textId={textId} iconName={iconName} padding="9px" />
}
